import React from "react";
import {authActions, Loader, modal, utils} from "@mc/mc-legacy";
import {faFileExport, faPenAlt, faPlus} from "@fortawesome/free-solid-svg-icons";
import CardMenu from "./CardMenu";
import {
    getPozadavkyMenuItems,
    getPrePozadavkyMenuItems,
    getSchvaleniMenuItems,
    getUkolyMenuItems
} from "../const/MenuItems";
import "./GroupMenu.scss";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import * as pozadavkyActions from "../actions/pozadavkyNevyrizeneActions";
import * as groupMenuActions from "../actions/groupMenuActions";
import * as groupMenuConfigActions from "../actions/groupMenuConfigActions";
import * as mojeUkolyActions from "../actions/mojeUkolyActions";
import Button from "reactstrap/es/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import CardMenuButton from "./CardMenuButton";
import SignRequestInternalApi from "../api/gen/qsign/SignRequestInternalApi";
import NovyVlastniPozadavekForm from "./forms/NovyVlastniPozadavekForm";
import * as pdfViewerActions from "../actions/pdfViewerActions";
import PodepisovaniPdfViewer from "./PodepisovaniPdfViewer";
import NovyPozadavekForm from "./forms/NovyPozadavekForm";
import MenuCountsVO from "../api/gen/qsign/types/MenuCountsVO";
import NovyPozadavekLegacyForm from "./forms/NovyPozadavekLegacyForm";
import TypeSign from "../api/gen/qsign/types/TypeSign";

const {storeFromArea} = utils;

/**
 * Group menu.
 */

class GroupMenu extends React.Component {

    componentDidMount() {
        this.fetchData(this.props, false);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.fetchData(nextProps, false);
    }

    fetchData = (props, forceFetch) => {
        const {dispatch} = props;
        dispatch(groupMenuActions.fetchIfNeeded(forceFetch));
        dispatch(groupMenuConfigActions.fetchIfNeeded(forceFetch));
    };

    showHromadnePodepsani = async () => {
        const {onCloseAction} = this.props;

        const requestConfig = await SignRequestInternalApi.getRequestConfig().then((res) => {
            return res
        });

        const newForm = 'new' === requestConfig.batchForm.toLowerCase();

        let initialValues;
        let form;
        if (newForm) {
            form = NovyPozadavekForm;
            initialValues = { files: [] }
        } else {
            form = NovyPozadavekLegacyForm;
            initialValues = {
                files: [],
                typeSign: TypeSign.CUSTOM
            }
        }

        //fullpage,
        this.props.dispatch(
            modal.ModalActions.showAsyncWaiting(
                "Načítání detailu šablony",
                <Loader/>,
                SignRequestInternalApi.getUserCombinations(),
                (typeCombinationItems) => {
                    this.props.dispatch(modal.ModalActions.show(
                        form,
                        {
                            onSubmit: (data) => {

                                const {files, signers, _filesHack, ...other} = data;
                                const documents = files.filter((x) => x.attachment === false);
                                const tempAttachments = files.filter((x) => x.attachment === true);
                                const attachments = [];
                                tempAttachments.map((attachment) => {
                                    attachments.push({
                                        name: attachment.name.split(".").slice(0, -1).join("."),
                                        fileName: attachment.name,
                                        uuid: attachment.uuid,
                                    });
                                });
                                const signersFinal = [];
                                if (signers && signers.length > 0) {
                                    signers.map((item) =>
                                        signersFinal.push({
                                            pracovnikId: item.pracovnikId,
                                            signerDescription: item.signerDescription
                                        })
                                    );
                                }
                                return SignRequestInternalApi.signDocuments({
                                    documents,
                                    attachments,
                                    signers: signersFinal,
                                    ...other
                                });
                            },
                            onSubmitSuccess: () => {
                                this.props.dispatch(pozadavkyActions.invalidate());
                                this.props.dispatch(groupMenuActions.invalidate());
                                this.props.dispatch(modal.ModalActions.hide());
                                this.props.history.push("/pozadavky/nevyrizene");
                                onCloseAction && onCloseAction();
                            },
                            onClose: () => {
                                onCloseAction && onCloseAction();
                            },
                            initialValues: initialValues,
                            typeCombinationItems: typeCombinationItems,
                        },
                        "Nový požadavek na podpis dokumentů",
                        {
                            size: "full",
                            toggle: () => {
                            }
                        },
                    ))
                })
        );
    };
    showVlastniHromadnePodepsani = () => {
        const {onCloseAction} = this.props;
        //fullpage,
        this.props.dispatch(
            modal.ModalActions.showAsyncWaiting(
                "Načítání detailu šablony",
                <Loader/>,
                SignRequestInternalApi.getUserCombinations(),
                (typeCombinationItems) => {
                    this.props.dispatch(modal.ModalActions.show(
                        NovyVlastniPozadavekForm,
                        {
                            onSubmit: (data) => {
                                const {files, _filesHack, ...other} = data;
                                const documents = files.filter((x) => x.attachment === false);
                                const tempAttachments = files.filter((x) => x.attachment === true);
                                const attachments = [];
                                tempAttachments.map((attachment) => {
                                    attachments.push({
                                        name: attachment.name.split(".").slice(0, -1).join("."), // TODO jakubčík: vážně to tak chceme?
                                        fileName: attachment.name,
                                        uuid: attachment.uuid,
                                    });
                                });
                                return SignRequestInternalApi.ownSignDocuments({documents, attachments, ...other});
                            },
                            onSubmitSuccess: (signRequest, dispatch) => {
                                this.props.dispatch(mojeUkolyActions.invalidateMuNevyrizene());
                                this.props.dispatch(groupMenuActions.invalidate());
                                this.props.dispatch(modal.ModalActions.hide());
                                onCloseAction && onCloseAction();
                                dispatch(pdfViewerActions.showDocuments(
                                    signRequest,
                                    false,
                                    null,
                                    () => {
                                        onCloseAction && onCloseAction();
                                    },
                                    PodepisovaniPdfViewer.VIEW_MODE.BASE
                                ));
                            },
                            onClose: () => {
                                onCloseAction && onCloseAction();
                            },
                            initialValues: {
                                files: [],
                            },
                            typeCombinationItems: typeCombinationItems
                        },
                        "Nový požadavek na vlastní podpis dokumentů",
                        {
                            size: "full",
                        }
                    ));
                }
            )
        );
    };
    novyVlastniPozadavekButton = <Button onClick={this.showVlastniHromadnePodepsani}
                                         className={"w-100 py-1 d-flex btn-novy-vlastni"}><span
        className={"d-flex align-items-center w-100"}><FontAwesomeIcon className={"mr-3"} size={"1x"} icon={faPlus}/> Nový vlastní požadavek</span></Button>

    novyPozadavekButton = <Button onClick={this.showHromadnePodepsani}
                                  className={"w-100 py-1 d-flex btn-novy-pozadavek"}><span
        className={"d-flex align-items-center w-100"}><FontAwesomeIcon className={"mr-3"} size={"1x"} icon={faPlus}/> Nový požadavek</span></Button>

    static showGroupMenuPrePozadavky(groupMenu: MenuCountsVO): boolean {
        const preMpNevyrizene = groupMenu && groupMenu.preMpNevyrizene;
        return preMpNevyrizene > 0;
    }

    mamPodepsatCard = () => {
        const {groupMenu, groupMenuConfig, isSigner} = this.props;
        if (isSigner) {
            return (<div className="menu menu--ukoly">
                    <CardMenuButton items={getUkolyMenuItems(groupMenu.data)}
                                    title="Mám podepsat"
                                    icon={faPenAlt}
                                    color="#219653"
                                    button={groupMenuConfig && groupMenuConfig.data && groupMenuConfig.data.ownSignsEnabled && this.novyVlastniPozadavekButton}/>
                </div>
            )
        }
    }

    mnouPredlozenoCard = () => {
        const {admin, groupMenu, groupMenuConfig, isSigner, canCreateRequest} = this.props;
        if (!isSigner || canCreateRequest) {
            return (
                <div className="menu menu--pozadavky">
                    <CardMenuButton
                        button={groupMenuConfig && groupMenuConfig.data && groupMenuConfig.data.requestsEnabled && this.novyPozadavekButton}
                        items={getPozadavkyMenuItems(groupMenu.data)}
                        title={admin ? "Vše předložené" : "Mnou předloženo"}
                        icon={faFileExport}
                        color="#f2c94c"
                    />
                </div>
            )
        }
    }

    mamSchvalitCard = () => {
        const {groupMenu, isApprover} = this.props;
        if (isApprover) {
            return (
                <div className="menu">
                    <CardMenu
                        items={getSchvaleniMenuItems(groupMenu.data)}
                        title={"Mám schválit"}
                        icon={faPenAlt}
                        color="#4ea8de"
                    />
                </div>
            )
        }
    }

    predbezneCard = () => {
        const {groupMenu} = this.props;
        if (GroupMenu.showGroupMenuPrePozadavky(groupMenu.data)) {
            return (
                <div className="menu">
                    <CardMenu
                        items={getPrePozadavkyMenuItems(groupMenu.data)}
                        title={"Předběžné"}
                        icon={faPenAlt}
                        color="#a44ede"
                    />
                </div>
            )
        }
    }

    render() {
        const {viewOrder} = this.props;
        console.log("=>(GroupMenu.tsx:251) viewOrder", viewOrder);
        return (
            <div className="group-menu">
                {viewOrder.map((view) => {
                    switch (view) {
                        case 'SIGN':
                            return this.mamPodepsatCard();
                        case 'REQUEST':
                            return this.mnouPredlozenoCard();
                        case 'APPROVE':
                            return this.mamSchvalitCard();
                        case 'PREREQUEST':
                            return this.predbezneCard();
                    }
                })}
            </div>
        );
    }
}

export default withRouter(connect((state, props) => {
    const authInfo = storeFromArea(state, authActions.AUTH_INFO_AREA);
    const groupMenu = storeFromArea(state, groupMenuActions.GROUP_MENU);
    const groupMenuConfig = storeFromArea(state, groupMenuConfigActions.GROUP_MENU_CONFIG);
    return {
        admin: authInfo.data.admin,
        isApprover: authInfo.data.approver,
        isSigner: !authInfo.fetched || authInfo.data.signer,
        canCreateRequest: !authInfo.fetched || authInfo.data.canCreateRequest,
        viewOrder: authInfo.data.views,
        groupMenu,
        groupMenuConfig
    };
})(GroupMenu));
